var _rect, _g, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup4661(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 328,
    height: 200,
    viewBox: "0 0 328 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_175",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 328,
    height: 200
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 328,
    height: 200,
    rx: 24,
    fill: "#4611A7"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_175)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 328,
    height: 200,
    rx: 24,
    fill: "#E1E6F5"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M164 102.426L367.849 94.9824V108.725L164 104.144V102.426Z",
    fill: "#EDF0FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164 104.142L-39.849 111.014V97.271L164 102.425V104.142Z",
    fill: "#EDF0FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.428 102.996L155.984 -100.853H169.727L165.146 102.996H163.428Z",
    fill: "#EDF0FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.144 102.996L172.016 306.845H158.273L163.426 102.996H165.144Z",
    fill: "#EDF0FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.475 102.771L237.933 -87.139L250.536 -81.6592L165.05 103.456L163.475 102.771Z",
    fill: "#EDF0FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.05 103.455L90.067 293.137L77.4642 287.657L163.475 102.77L165.05 103.455Z",
    fill: "#EDF0FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.471 103.218L78.5841 -82.2655L91.2807 -87.5246L165.058 102.56L163.471 103.218Z",
    fill: "#EDF0FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.062 102.561L249.42 288.264L236.723 293.523L163.475 103.219L165.062 102.561Z",
    fill: "#EDF0FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.404 102.594L313.811 241.473L304.093 251.191L163.19 103.808L164.404 102.594Z",
    fill: "#EDF0FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.191 103.809L14.189 -35.475L23.9065 -45.1925L164.405 102.595L163.191 103.809Z",
    fill: "#EDF0FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.22 102.465L355.4 173.598L350.141 186.294L163.562 104.052L164.22 102.465Z",
    fill: "#EDF0FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.561 104.052L-27.4003 32.3908L-22.1412 19.6942L164.219 102.465L163.561 104.052Z",
    fill: "#EDF0FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.594 102.594L302.473 -46.8129L312.191 -37.0954L164.808 103.808L163.594 102.594Z",
    fill: "#EDF0FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.811 103.807L25.5269 252.809L15.8094 243.091L163.596 102.593L164.811 103.807Z",
    fill: "#EDF0FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.782 102.463L349.265 17.5763L354.525 30.2728L164.44 104.05L163.782 102.463Z",
    fill: "#EDF0FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.441 104.052L-21.2616 188.41L-26.5207 175.713L163.783 102.465L164.441 104.052Z",
    fill: "#EDF0FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.113 102.436L365.637 134.025L363.015 147.515L163.785 104.122L164.113 102.436Z",
    fill: "#EDF0FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.782 104.124L-37.633 71.9729L-35.0108 58.4828L164.11 102.438L163.782 104.124Z",
    fill: "#EDF0FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.436 102.891L195.025 -98.633L208.515 -96.0108L165.122 103.219L163.436 102.891Z",
    fill: "#EDF0FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.122 103.218L132.971 304.633L119.481 302.011L163.436 102.89L165.122 103.218Z",
    fill: "#EDF0FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.529 102.675L272.856 -69.5383L284.182 -61.7544L164.945 103.648L163.529 102.675Z",
    fill: "#EDF0FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.947 103.647L55.148 275.536L43.8224 267.752L163.531 102.674L164.947 103.647Z",
    fill: "#EDF0FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.439 103.12L115.503 -95.1529L128.97 -97.8928L165.122 102.777L163.439 103.12Z",
    fill: "#EDF0FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.122 102.776L212.497 301.163L199.03 303.903L163.439 103.119L165.122 102.776Z",
    fill: "#EDF0FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.477 102.678L284.639 267.514L273.246 275.199L163.053 103.639L164.477 102.678Z",
    fill: "#EDF0FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.052 103.638L43.3646 -61.518L54.7577 -69.2028L164.476 102.677L163.052 103.638Z",
    fill: "#EDF0FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.317 102.524L338.413 208.828L330.828 220.288L163.369 103.956L164.317 102.524Z",
    fill: "#EDF0FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.367 103.956L-10.4126 -2.82625L-2.8275 -14.286L164.315 102.523L163.367 103.956Z",
    fill: "#EDF0FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.678 102.527L328.514 -17.6354L336.199 -6.24229L164.639 103.951L163.678 102.527Z",
    fill: "#EDF0FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.642 103.95L-0.514101 223.637L-8.19888 212.244L163.681 102.526L164.642 103.95Z",
    fill: "#EDF0FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.886 102.439L362.159 54.5036L364.899 67.9703L164.229 104.122L163.886 102.439Z",
    fill: "#EDF0FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.228 104.124L-34.159 151.498L-36.8988 138.032L163.885 102.441L164.228 104.124Z",
    fill: "#EDF0FA"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M249.25 26.1377L250.852 27.5423L258.841 20.466L254.185 17.4558L249.25 26.1377Z",
    fill: "#FF8C96"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M172.243 21.1221C170.843 20.8397 169.538 20.2106 168.473 19.2182C167.407 18.2258 166.71 16.9929 166.37 15.6557L165.911 15.6676C165.589 17.0217 164.909 18.2905 163.857 19.3367C162.805 20.3829 161.511 21.0799 160.114 21.4348L160.118 21.8758C161.519 22.1581 162.823 22.7875 163.888 23.7799C164.954 24.7723 165.651 26.0052 165.991 27.3415L166.45 27.3298C166.771 25.9755 167.451 24.7069 168.503 23.6607C169.555 22.6145 170.85 21.9178 172.246 21.5631L172.243 21.1221Z",
    fill: "#4611A7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M153.425 21.2463C152.639 21.0734 151.91 20.7061 151.319 20.1365C150.729 19.5669 150.348 18.8654 150.169 18.1087L149.911 18.1108C149.716 18.8706 149.321 19.5788 148.717 20.1579C148.114 20.737 147.378 21.117 146.588 21.3032L146.586 21.5517C147.372 21.7245 148.101 22.092 148.691 22.6616C149.282 23.2312 149.663 23.9327 149.841 24.689L150.099 24.6869C150.294 23.927 150.689 23.2189 151.293 22.6398C151.896 22.0607 152.632 21.6809 153.422 21.4948L153.425 21.2463Z",
    fill: "#4611A7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M185.425 21.2463C184.639 21.0734 183.91 20.7061 183.319 20.1365C182.729 19.5669 182.348 18.8654 182.169 18.1087L181.911 18.1108C181.716 18.8706 181.321 19.5788 180.717 20.1579C180.114 20.737 179.378 21.117 178.588 21.3032L178.586 21.5517C179.372 21.7245 180.101 22.092 180.691 22.6616C181.282 23.2312 181.663 23.9327 181.841 24.689L182.099 24.6869C182.294 23.927 182.689 23.2189 183.293 22.6398C183.896 22.0607 184.632 21.6809 185.422 21.4948L185.425 21.2463Z",
    fill: "#4611A7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M45.2899 43.5121C46.568 42.0789 48.4509 41.0819 50.3574 41.1954C52.2638 41.3089 54.111 42.7059 54.3865 44.5848C54.5021 45.3534 54.2162 46.3234 53.4506 46.5044C52.8117 46.6567 52.1676 46.1167 52.0288 45.4837C51.89 44.8508 52.1453 44.1866 52.5122 43.6444C53.5281 42.1421 55.421 41.3309 57.2284 41.4313C59.0359 41.5317 60.7262 42.4669 61.9234 43.7984",
    stroke: "#FF8D96",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M240.067 51.2097C239.842 51.2289 239.688 50.9955 239.61 50.7857C239.039 49.2203 240.03 47.3804 241.513 46.582C242.996 45.7836 244.807 45.8513 246.424 46.2963C246.785 46.3959 247.156 46.5218 247.418 46.7889C247.68 47.0543 247.797 47.4991 247.585 47.8107C247.468 47.9855 247.267 48.0923 247.063 48.146C246.286 48.3506 245.401 47.7636 245.3 46.9734C245.172 45.9895 246.068 45.1804 246.92 44.6543C248.389 43.7444 250.003 43.0689 251.683 42.6642",
    stroke: "#50DC6E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M76.0749 21.4215L81.4105 16.2283L87.9219 27.1698L85.3973 29.4049L76.0749 21.4215Z",
    fill: "#50DC6E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup4661);
export default __webpack_public_path__ + "static/media/Group4661.f8073e96ebc7b8bdab4095ab14a13ffb.svg";
export { ForwardRef as ReactComponent };